<div class="logo" [style.padding]="iconStyle" [style.--max-width-desktop]="maxWidthDesktop"
     [style.--max-width-mobile]="maxWidthMobile">
     <img [src]="image" alt="KlickData" (click)="redirectTo()" [style.maxHeight]="iconImgStyleHeight" class="logo-image"
          (load)="onImageLoad($event)">
</div>